import { ApiResponse, GlobalStore, GridStore } from "@roc/feature-app-core";
import { NewLeadService } from "@roc/feature-new-lead";
import { GENERIC_ERROR_MESSAGE } from "@roc/feature-utils";
import { flow, makeObservable, observable } from "mobx";

import { BaseLeadStore } from "libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore";
import { CadenceStore } from "libs/client-portal-shared/src/app/modules/companyProfile/stores/cadenceStore/cadenceStore";
import { CadenceService } from "libs/client-portal-shared/src/app/modules/companyProfile/services/cadenceServices/cadenceService";

const PAGE_SIZE = 100;
export class ProspectsByOriginatorGridStoreV2 extends GridStore {
  private globalStore: GlobalStore;
  private cadenceStore: CadenceStore;
  private cadenceService: CadenceService;

  constructor(globalStore: GlobalStore, cadenceStore) {
    super(() => this.fetchRows(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.cadenceStore = cadenceStore;
    this.cadenceService = new CadenceService();
  }

  fetchRows = async () => {
    try {
      return await this.cadenceService.getProspectsByOriginator(this.cadenceStore.cadence?.cadenceId)
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };

}